module.exports = __webpack_public_path__ + "static/media/JS2.98582e43.PNG";